import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { cart, currentOrder, updateItemQuantity, submitCCStatus, submitStatus, removeItemFromOrder } from '../reducers/cart';

import { getUser, getSubsite, reloadUser, getSubsiteBalance } from '../reducers/auth';
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { resolveImageUrl } from '../utils/imageUrl';

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const Checkout = () => {
  let navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const cartItems = useSelector(cart);
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const [paymentType, setPaymentType] = useState("balance");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const currentSubsite = useSelector(getSubsite);
  const currentSubsiteBalance = useSelector(getSubsiteBalance);
  const [shipping, setShipping] = useState();
  const [total, setTotal] = useState(0.0);
  const [itemCount, setItemCount] = useState(0);

  console.log("CURRENT SUBSITE", currentSubsite);

  useEffect(() => {
    dispatch(reloadUser());
  }, [dispatch]);

  useEffect(() => {

    console.log("CART ITEMS", cartItems);
    var newtotal = 0.0;
    var totalCount = 0.0;

    for (var i = 0; i < cartItems.length; i++) {
      // Skip bill later items in total calculation (price may be null or 0)
      const price = cartItems[i].price || 0;
      const isPrintItem = !!cartItems[i].printItemId;

      if (isPrintItem) {
        // For print items, price is always stored as total
        newtotal += price;
      } else {
        // For regular products, check pricing type
        const pricingType = cartItems[i].product?.pricingType;
        if (pricingType === PRICING_TYPES.QUANTITY) {
          newtotal += price;
        } else {
          newtotal += price * cartItems[i].quantity;
        }
      }
      totalCount += cartItems[i].quantity;
    }
    console.log("USER IN CHECKOUT", currentSubsiteBalance);
    if (currentSubsiteBalance && newtotal > currentSubsiteBalance.balance) {
      setPaymentType("split");
      getShipping("split");
    } else {
      setPaymentType("balance");
      getShipping("balance");
    }
    setTotal(newtotal);
    setItemCount(totalCount);

  }, [cartItems, user]);
  //  useEffect(() => {
  //    });
  //}, [currOrder]);

  /*cartItems.map(item => {
    total += item.price * item.quantity;
    totalCount += item.quantity;
  });*/

  useEffect(() => {
    async function fetchData() {
      var newTotal = 0.0;
      var newItemCount = itemCount;
      for (var i = 0; i < cartItems.length; i++) {
        // Skip bill later items in total calculation (price may be null or 0)
        const price = cartItems[i].price || 0;
        const isPrintItem = !!cartItems[i].printItemId;

        if (isPrintItem) {
          // For print items, price is always stored as total
          newTotal += price;
        } else {
          // For regular products, check pricing type
          const pricingType = cartItems[i].product?.pricingType;
          if (pricingType === PRICING_TYPES.QUANTITY) {
            newTotal += price;
          } else {
            newTotal += price * cartItems[i].quantity;
          }
        }
        newItemCount += cartItems[i].quantity;
      }
      console.log("NEW TOTAL", newTotal);
      setTotal(newTotal);
      setItemCount(newItemCount);
    }
    fetchData();
  }, []);

  const typeChanged = (event) => {
    setPaymentType(event.target.id);
  }

  const handleOrder = (event) => {
    navigate("/payment");
  }

  const removeCartItem = (item) => {
    console.log("CART ITEM", item);
    dispatch(removeItemFromOrder(item.id));
  }

  const formatPantsSize = (sizeName) => {
    var isFour = /^\d{4}$/.test(sizeName);
    if (isFour) {
      return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }

  const getShipping = async (type) => {
    if (!type) type = paymentType;
    var weight = 0.0;
    cartItems.map(item => {
      weight += item.product.weight * item.quantity;
    });

    console.log("GET SHIPPING", weight);
    //var shipping = await ShippingService.getShipping({weight: weight, orderId: currOrder.id, paymentType: type, balance: user.balance});
    console.log("GET SHIPPING2", shipping);
    //setShipping(shipping.data);
    //shippingCost = shipping.data;
  }


  const qtyChanged = (item, event) => {
    let args = { item: item, quantity: parseInt(event.target.value) };
    dispatch(updateItemQuantity(args));
  }

  return (
    <div className="container" style={{ paddingTop: 20, paddingBottom: 100 }}>
      {cartItems.length === 0 && (
        <div class="alert">Your cart is empty. Please add items to your cart before checking out.</div>
      )}
      {cartItems.length > 0 && (
        <>
          {(currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit")) && (

            <Container>
              <Row>
                <Col xs={12} style={{ marginLeft: 40 }}>
                  {currentSubsite.paymentOptions == "creditcard" && (
                    <div class="content">
                    </div>
                  )}
                  {currentSubsite.paymentOptions == "balance creditcard" && (
                    <div class="content">
                      {!currentSubsiteBalance || total > currentSubsiteBalance.balance &&
                        <div class="alert">Your total is more than your available balance.
                          Your balance will be used up and the remaining balance will charged to your credit card.<br />
                          Balance Remaining: {currentSubsiteBalance?.balance.toLocaleString(undefined, {
                            style: "currency",
                            currency: "USD",
                          })}
                        </div>
                      }
                    </div>
                  )}
                  {currentSubsite.paymentOptions === "balance" && (
                    <div className="content">
                      {total > currentSubsiteBalance?.balance &&
                        <div className="alert">Your total is more than your available balance. Please remove items from your cart.
                        </div>
                      }
                      {currentSubsite.maxOrdersPerBalance > 0 &&
                        currentSubsiteBalance?.balanceRollsOver &&
                        (currentSubsiteBalance.ordersAgainstBalance || 0) >= currentSubsite.maxOrdersPerBalance && (
                        <div className="alert">
                          You have used all {currentSubsite.maxOrdersPerBalance} allowed order(s) for your current balance.
                        </div>
                      )}
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          )}
          <div>
            <div class="review-container">
              <div class="content">

                <div class="cart-item-container">
                  {(currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit")) && (
                    <div class="price-label">PRICE</div>
                  )}
                  <Container className="mt-5" style={{ marginBottom: "150px" }}>
                    {cartItems.map(item => {
                      const isPrintItem = !!item.printItemId;
                      const pricingType = isPrintItem ? item.print_item?.pricingType : item.product?.pricingType;

                      return (
                        <Row className="checkout-item" key={item.id}>
                          <Col sm={3} className="d-flex justify-content-center align-items-center">
                            <div style={{ position: "relative", width: "150px" }}>
                              {isPrintItem ? (
                                <img className="bg-image" src={item.print_item?.imageUrl?.includes('uploads') ? apiUrl + item.print_item.imageUrl : item.print_item?.imageUrl} width={150}></img>
                              ) : (
                                <>
                                  <img className="bg-image" src={resolveImageUrl(item.product?.frontModelImage)} width={150}></img>
                                  {item.decorations && item.decorations.map((logo, i) => (
                                    <img key={i} className="logo-image" src={apiUrl + logo.decoration_logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
                                  ))}
                                </>
                              )}
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div class="content" style={{ position: "relative" }}>
                              {isPrintItem ? (
                                <>
                                  <div class="title">{item.print_item?.title}</div>
                                  <div class="quantity">Quantity: {item.quantity}</div>
                                </>
                              ) : (
                                <>
                                  <div class="title">{item.product?.style?.title}</div>
                                  <div class="color">Color: {item.colorName}</div>
                                  <div class="size-name">Size: {formatPantsSize(item.sizeName)}</div>
                                  {/* For quantity pricing, show quantity as text (not editable) */}
                                  {pricingType === PRICING_TYPES.QUANTITY && (
                                    <div class="quantity">Quantity: {item.quantity}</div>
                                  )}
                                  {/* For flat pricing and bill later, show quantity dropdown */}
                                  {currentSubsite.paymentOptions != "kit" && pricingType !== PRICING_TYPES.QUANTITY && (
                                  <div class="quantity">
                                    <Form.Select label="Quantity" onChange={(event) => qtyChanged(item, event)} value={item.quantity}>
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                      <option value="4">4</option>
                                      <option value="5">5</option>
                                      <option value="6">6</option>
                                      <option value="7">7</option>
                                      <option value="8">8</option>
                                      <option value="9">9</option>
                                      <option value="10">10</option>
                                    </Form.Select>
                                  </div>
                                  )}
                                </>
                              )}
                              {/* Display personalization values */}
                              {item.order_item_personalizations && item.order_item_personalizations.length > 0 && (
                                <div style={{ marginTop: 8, padding: 8, backgroundColor: '#f8f9fa', borderRadius: 4 }}>
                                  <strong style={{ fontSize: '0.9em' }}>Personalization:</strong>
                                  {item.order_item_personalizations.map((p, idx) => {
                                    const field = p.personalization_field;
                                    const mappings = field?.personalization_field_deco_colors || field?.colorMappings || [];
                                    let decoColor = null;
                                    if (item.colorName && mappings.length) {
                                      const map = mappings.find(m =>
                                        (m.color?.colorName && m.color.colorName === item.colorName) ||
                                        (m.colorName && m.colorName === item.colorName)
                                      );
                                      decoColor = map?.deco_color || map?.decoColor || null;
                                    }
                                    if (!decoColor) {
                                      decoColor = field?.deco_color || field?.decoColor || null;
                                    }
                                    return (
                                    <div key={idx} style={{ fontSize: '0.85em', marginTop: 2 }}>
                                      <span style={{ color: '#555' }}>{p.fieldName || field?.name || 'Field'}:</span> {p.fieldValue}
                                      {decoColor?.colorName && (
                                        <span style={{ color: '#777' }}> ({decoColor.colorName})</span>
                                      )}
                                    </div>
                                    );
                                  })}
                                </div>
                              )}
                              {currentSubsite.paymentOptions != "kit" && (
                                <Button variant="primary" onClick={() => { removeCartItem(item) }}>Remove</Button>
                              )}
                            </div>
                          </Col>
                          {(currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit")) && (

                            <Col sm={2}>
                              {/* For bill later, show "Billed Later" instead of price */}
                              {pricingType === PRICING_TYPES.BILL_LATER ? (
                                <div class="price" style={{ textAlign: "right", justifyContent: "flex-end", fontStyle: "italic", color: "#666" }}>Billed Later</div>
                              ) : isPrintItem || pricingType === PRICING_TYPES.QUANTITY ? (
                                /* For print items or quantity pricing, the price is already the total */
                                <div class="price" style={{ textAlign: "right", justifyContent: "flex-end" }}>{(item.price || 0).toLocaleString(undefined, { style: "currency", currency: "USD" })}</div>
                              ) : (
                                <div class="price" style={{ textAlign: "right", justifyContent: "flex-end" }}>{((item.price || 0) * item.quantity).toLocaleString(undefined, { style: "currency", currency: "USD" })}</div>
                              )}
                            </Col>
                          )}
                        </Row>
                      );
                    })

                    }
                  </Container>
                  {(currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit")) && (
                    <>
                      <div class="total">Subtotal: <strong>{(total).toLocaleString(undefined, {
                        style: "currency",
                        currency: "USD",
                      })}</strong><br /></div>
                      {shipping && shipping.shippingAmount && (
                        <div class="total">Shipping: <strong>{(shipping?.shippingAmount?.amount).toLocaleString(undefined, {
                          style: "currency",
                          currency: "USD",
                        })}</strong><br /></div>
                      )}
                      {currentSubsiteBalance?.balance > 0 && (
                        <div class="total">Balance: <strong>{(currentSubsiteBalance?.balance).toLocaleString(undefined, {
                          style: "currency",
                          currency: "USD",
                        })}</strong><br /></div>
                      )}
                    </>
                  )}

                  {currentSubsite.paymentOptions == "balance" && (
                    total > currentSubsiteBalance?.balance ||
                    (currentSubsite.maxOrdersPerBalance > 0 &&
                      currentSubsiteBalance?.balanceRollsOver &&
                      (currentSubsiteBalance.ordersAgainstBalance || 0) >= currentSubsite.maxOrdersPerBalance)
                  ) && (
                    <Button variant="warning" disabled={true}
                      onClick={handleOrder}>Continue to Payment</Button>

                  )}
                  {(currentSubsite.paymentOptions == "balance" &&
                    total <= currentSubsiteBalance?.balance &&
                    !(currentSubsite.maxOrdersPerBalance > 0 &&
                      currentSubsiteBalance?.balanceRollsOver &&
                      (currentSubsiteBalance.ordersAgainstBalance || 0) >= currentSubsite.maxOrdersPerBalance)
                  )
                    && (
                      <Button variant="warning" disabled={isSubmitting}
                        onClick={handleOrder}>Continue to Payment</Button>
                    )}

                  {(currentSubsite.paymentOptions == "itemlimit" && itemCount > currentSubsiteBalance?.balance) && (
                    <div style={{ padding: 20, alignSelf: "center", fontWeight: 500, color: "#990000" }}>You ordered {itemCount} of {currentSubsiteBalance.balance.toFixed()} items. Please remove items from your cart.</div>
                  )}

                  {(currentSubsite.paymentOptions == "itemlimit" && itemCount <= currentSubsiteBalance?.balance) && (
                    <div style={{ padding: 20, alignSelf: "center", fontWeight: 500 }}>You ordered {itemCount} of {currentSubsiteBalance.balance.toFixed()} items.</div>
                  )}

                  <div style={{fontWeight: 800, color:"#800000", padding:25, textAlign: "center", paddingLeft: "20%", paddingRight: "20%"}}>
                    All items are decorated on demand. Decorated items are non-returnable, other than errors on the part of Ignite, manufacturer defects, or decoration errors.
                  </div>

                  {(currentSubsite.paymentOptions == "itemlimit" && itemCount <= currentSubsiteBalance?.balance)
                    && (
                      <Button variant="warning" disabled={isSubmitting}
                        onClick={handleOrder}>Continue to Payment</Button>
                    )}
                  {(currentSubsite.paymentOptions == "kit")
                    && (
                      <Button variant="warning" disabled={isSubmitting}
                        onClick={handleOrder}>Continue to Payment</Button>
                    )}

                  {(currentSubsite.paymentOptions == "demo")
                    && (
                      <Button variant="warning" disabled={isSubmitting}
                        onClick={handleOrder}>Continue to Demo Checkout</Button>
                    )}

                  {((currentSubsite.paymentOptions.includes("balance") && currentSubsite.paymentOptions.includes("creditcard")) ||
                    currentSubsite.paymentOptions == "creditcard")
                    && (
                      <Button variant="warning" disabled={isSubmitting}
                        onClick={handleOrder}>Continue to Payment</Button>
                    )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Checkout;